(function () {
  document.querySelectorAll('[data-collection-description]').forEach((description) => {
    if (description.dataset.collectionDescriptionInitialized === 'true') return;
    description.dataset.collectionDescriptionInitialized = 'true';

    const wrapper = description.closest('.collection-hero__description-wrapper');
    const toggle = wrapper?.querySelector('[data-collection-description-toggle]');

    if (!toggle) return;

    const moreLabel = toggle.querySelector('[data-collection-description-more]');
    const lessLabel = toggle.querySelector('[data-collection-description-less]');
    let resizeTimer;

    function setExpanded(expanded) {
      description.classList.toggle('is-expanded', expanded);
      toggle.setAttribute('aria-expanded', String(expanded));
      moreLabel.hidden = expanded;
      lessLabel.hidden = !expanded;
    }

    function updateToggle() {
      setExpanded(false);
      toggle.hidden = description.scrollHeight <= description.clientHeight + 1;
    }

    toggle.addEventListener('click', () => {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateToggle, 150);
    });
    updateToggle();
  });
})();
